import { useCallback, useState } from 'react';
import { api } from '../../api/client';
import { playerSchema } from '../../api/types';
import { useAuth } from '../../auth/AuthProvider';
import { TelegramLoginButton } from '../../components/TelegramLoginButton';
import { MascotWatermark } from '../../components/Watermark';

/**
 * Гейт обязательной привязки Telegram — показывается после входа через веб
 * (email OTP), пока у аккаунта нет строки в telegram_links. Сервер в этом
 * состоянии отдаёт 403 на всё, кроме GET /me и самой привязки, так что экран
 * не обходится. В Telegram-webview сюда не попасть: initData линкует сам.
 */
export function LinkTelegramScreen() {
  const auth = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onTelegram = useCallback(
    async (user: Record<string, unknown>) => {
      setBusy(true);
      setError(null);
      try {
        const player = await api.post('/me/telegram', playerSchema, user);
        auth.applyPlayer(player);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Не удалось привязать Telegram');
      } finally {
        setBusy(false);
      }
    },
    [auth],
  );

  return (
    <div className="auth auth--brand">
      <MascotWatermark pos="center" />
      <img className="auth-logo" src="/ante-white.svg" alt="ANTÉ" />
      <div className="auth-title">Привяжите Telegram</div>
      <div className="auth-sub">
        Клуб живёт в Telegram: запись на турниры, напоминания и уведомления приходят туда.
        Без привязки войти в приложение не получится.
      </div>

      {error && <div className="field-error auth-error">{error}</div>}
      {busy && <div className="auth-sub">Привязываем…</div>}

      <TelegramLoginButton onAuth={onTelegram} />

      <div className="auth-footer">
        Не тот аккаунт?{' '}
        <span className="auth-link-text" onClick={auth.logout}>
          Выйти
        </span>
      </div>
    </div>
  );
}
